import React from 'react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
var optionWrapperStyles = xcss({
  color: 'color.text',
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
export var restrictionOptionFormatter = function restrictionOptionFormatter(option) {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: optionWrapperStyles
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "space.100"
  }, option.icon, option.label));
};